module.exports = __webpack_public_path__ + "static/img/sr.5bd4f020.svg";